import { ApiGenericResponse } from "../ApiGenericResponse";
import { AxiosResponse } from "axios";

export class CheckTemplateVersionResData extends ApiGenericResponse {
    allowedInstallations: string[];
    notAllowedInstallations: string[];

    constructor(response: AxiosResponse) {
        super(response);
        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.AllowedInstallations) {
            this.allowedInstallations = new Array<string>();
            obj.AllowedInstallations.forEach((element) => {
                this.allowedInstallations.push(element);
            });
        }

        if (obj.NotAllowedInstallations) {
            this.notAllowedInstallations = new Array<string>();
            obj.NotAllowedInstallations.forEach((element) => {
                this.notAllowedInstallations.push(element);
            });
        }
    }
}
